import { debug } from "../../utils";

export const ACTION_DEVICE_AUTHORIZATIONS_CHANGED = "ACTION_DEVICE_AUTHORIZATIONS_CHANGED";

export function DeviceAuthorizationPageReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_DEVICE_AUTHORIZATIONS_CHANGED: {
            debug(`DeviceAuthorizationPageReducer ${ACTION_DEVICE_AUTHORIZATIONS_CHANGED} is being processed...`);
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}
